export default "__VITE_ASSET__W3JtZSMx__"